<template>
  <div style="position: relative; width: 100%; height: 100%">
    <iframe
      v-if="src"
      ref="myIFrame"
      style="position: absolute; width: 100%; height: 100%; border: 0px"
      :src="src"
    ></iframe>
  </div>
</template>
  
<script>
// import _ from "lodash";
import Axios from "@/config/customer-service";

export default {
  inject: ["isAppLoading"],
  props: {
    dataItem: { default: () => {} },
  },
  emits: [],
  components: {},
  data() {
    return {
      src: "",
    };
  },
  async created() {
    this.isAppLoading(true);
    const playable_url =
      this.dataItem?.external_data?.game_detail?.game_url?.playable_url || "";
    if (playable_url) {
      let ignore_cookie = "?iframe=true";
      // ignore_cookie = "";
      this.src = `${playable_url}${ignore_cookie}`;
    }
    if (this.src) {
      this.$nextTick(() => {
        this.setupIframeListener();
      });
    } else {
      this.isAppLoading(false);
    }
  },
  mounted() {
    // เพิ่ม listener เมื่อ component ถูก mount
    window.addEventListener("message", this.handleMessage);
  },
  beforeDestroy() {
    // ลบ listener เมื่อ component ถูก unmount เพื่อป้องกัน memory leaks
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
    redirectTo() {
      this.$router.push({
        name: "gamification-detail",
        params: {
          id: this.$route.params.id,
        },
      });
    },
    async sleep(msec) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, msec || 500);
      });
    },
    setupIframeListener() {
      const iframe = this.$refs.myIFrame;
      if (!iframe) {
        console.error("IFrame ref not found.");
        return;
      }

      const handleIframeLoad = () => {
        this.isAppLoading(false);
      };
      iframe.addEventListener("load", handleIframeLoad);
    },
    handleMessage(event) {
      // ตรวจสอบ origin ของผู้ส่งเพื่อความปลอดภัย
      // ใน production ควรเปลี่ยน "https://example.com" เป็น domain ที่เชื่อถือได้
      // if (event.origin !== "https://example.com") {
      //   return;
      // }

      // เก็บข้อมูลที่ได้รับจาก event.data
      const receivedMessage = event.data;
      // console.log("ข้อความที่ได้รับ:", receivedMessage);
      if (receivedMessage?.source == "gamemick") {
        this.handleMessageGamemick(receivedMessage);
      }
    },
    async handleMessageGamemick(param) {
      const payload = param.payload;
      if (payload) {
        const rewardSystem = payload.rewardSystem;
        if (rewardSystem == "REWARD_POOL") {
          const claim_reward_transaction = payload.claim_reward_transaction;
          const reward_uuid = claim_reward_transaction.rewardMasterUuid || null;
          await this.getResultGame(payload, reward_uuid);
        } else if (rewardSystem == "LEGACY") {
          const result = payload.result;
          const id = result.id || null;
          await this.getResultGame(payload, id);
        }
      }
    },
    async getResultGame(payload, id) {
      if (!payload) return;
      try {
        const response = await Axios.post(
          `gamification/getAndUpdateTransactionResultGame/${this.dataItem.id}`,
          {
            reward_uuid: id,
            item_json: payload,
          }
        );
        const dataResponse = response?.data;
        let itemJson = null;
        let errorMsg = "";
        if (dataResponse?.status == "success") {
          const data = dataResponse.data;
          itemJson = data?.result?.item_json;
        } else {
          errorMsg = dataResponse?.message;
        }
        if (itemJson) {
          // await this.sleep(2000);
          const text =
            !itemJson.hideText && itemJson.name
              ? `<div style="font-weight: 400; margin-bottom: 8px;">${this.$t(
                  "textCongratsReceived"
                )}<br/><div style="font-weight: 600;">${
                  itemJson.name
                }</div></div>`
              : ``;
          const image = itemJson.image
            ? `<img style="width: 100%; object-fit: contain;" src="${itemJson.image}" />`
            : ``;
          let html = `
            ${text}
            ${image}
          `;
          this.$swal
            .fire({
              icon: "success",
              html: html,
              showCancelButton: false,
              confirmButtonText: this.$t("viewHistory"),
              confirmButtonColor: "#2196F3",
              allowOutsideClick: false,
            })
            .then((result2) => {
              if (result2.isConfirmed) {
                this.$router.push({
                  name: "gamification-history",
                  params: { id: this.dataItem.id },
                });
              }
            });
        } else {
          const textError = errorMsg;
          const textBtn = this.$t("back");
          this.$swal
            .fire({
              icon: "warning",
              text: textError,
              showCancelButton: false,
              confirmButtonText: textBtn,
              confirmButtonColor: "#000000",
              allowOutsideClick: false,
            })
            .then((result) => {
              if (result.isConfirmed) {
                this.redirectTo();
              }
            });
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {},
  watch: {},
};
</script>
  
<style scoped>
</style>
